import Group from "./Group";

import "./style.scss";

export default Group;
